import { DateTime } from 'luxon';
import * as XLSX from 'xlsx';

function exportICS(events) {
  const icsContent = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Feuerwehr Schorndorf//Kalender//DE',
    ...events.map(event => {
      const dt = DateTime.fromISO(event.date).setZone('Europe/Berlin');
      const start = dt.toFormat("yyyyMMdd'T'HHmmss");
      const end = dt.plus({ hours: 1 }).toFormat("yyyyMMdd'T'HHmmss");
      return [
        'BEGIN:VEVENT',
        `DTSTART:${start}`,
        `DTEND:${end}`,
        `SUMMARY:${event.title}`,
        `DESCRIPTION:Kategorie: ${event.category}`,
        'END:VEVENT'
      ].join('\r\n');
    }),
    'END:VCALENDAR'
  ].join('\r\n');

  const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = 'feuerwehr_kalender.ics';
  link.click();
}

function exportCSV(events) {
  const headers = 'Datum,Uhrzeit,Titel,Kategorie';
  const rows = events.map(event => {
    const dt = DateTime.fromISO(event.date).setZone('Europe/Berlin');
    return [
      dt.toLocaleString(DateTime.DATE_FULL, { locale: 'de' }),
      dt.toLocaleString(DateTime.TIME_24_SIMPLE, { locale: 'de' }),
      event.title,
      event.category
    ].map(field => `"${field.replace(/"/g, '""')}"`).join(','); // Umlaute bleiben erhalten, escaped Quotes
  });

  // UTF-8 BOM hinzufügen für Excel-Kompatibilität
  const csvContent = '\uFEFF' + [headers, ...rows].join('\r\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = 'feuerwehr_kalender.csv';
  link.click();
}

function exportXLSX(events) {
  const worksheet = XLSX.utils.json_to_sheet(events.map(event => ({
    Datum: event.formattedDate,
    Uhrzeit: event.formattedTime,
    Titel: event.title,
    Kategorie: event.category
  })));
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Events');
  XLSX.writeFile(workbook, 'feuerwehr_kalender.xlsx');
}

export { exportICS, exportCSV, exportXLSX };